import React, { useEffect, useState } from "react";
import queryDialogflow from "../dialogflowService.js";
import { FaUser, FaRobot, FaPaperPlane } from "react-icons/fa";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import "./ChatComponent.css";
import axios from "axios";

const ChatComponent = ({ onSubmitData }) => {
  const [userInput, setUserInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [collectedData, setCollectedData] = useState({
    person: "",
    email: "",
    phone: "",
    concern: "",
    date: "",
    time: "",
  });
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isBotTyping, setIsBotTyping] = useState(false); // Typing indicator state
  const [showAppointmentBotText, setShowAppointmentBotText] = useState(true); // State to control "APPOINTMENTBOT" text visibility

  const chatMessagesRef = React.createRef();

  const scrollToBottom = () => {
    const messagesContainer = chatMessagesRef.current;
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    setCollectedData({
      person: "",
      email: "",
      phone: "",
      concern: "",
      date: "",
      time: "",
    });

    setMessages([
      {
        text: "Welcome! Ready to book an appointment? Please start by telling your name.",
        sender: "bot",
      },
    ]);

    const timeout = setTimeout(() => {
      setShowAppointmentBotText(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  const handleSubmit = async () => {
    try {
      const formattedDate = collectedData.date.split("T")[0];
      const formattedTime =
        collectedData.time.split("T")[1]?.split("+")[0] || collectedData.time;

      const isoString = `${formattedDate}T${formattedTime}`;
      const requestedDate = new Date(isoString);

      const appointmentData = {
        name: collectedData.person,
        concern: collectedData.concern,
        email: collectedData.email,
        phone: collectedData.phone,
        requestedDate: requestedDate.toISOString(),
      };

      await addDoc(collection(db, "appointments"), {
        ...appointmentData,
        createdAt: new Date(),
        status: "requested",
      });

      const response = await fetch(
        "https://us-central1-lakdawalaeyehospital-f9656.cloudfunctions.net/appointmentRequestEmail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(appointmentData),
        }
      );
      const smsResponse = await axios.post(
        "https://uzqjjogjuolaxcjdjpckj3vpim0obefc.lambda-url.ap-south-1.on.aws/",
        {
          phoneNumber: appointmentData.phone,
          message: `Dear ${appointmentData.name},\n\nYour appointment request has been submitted at Dr. Lakdawala Eye Hospital.\n\nDate: ${appointmentData.date}\nTime: ${appointmentData.time}\nConcern: ${appointmentData.concern}\n\nYou will be contacted soon for further details.\n\nThank you!`,
        },
        {
          headers: {
            "x-api-key": "dcf7a832-18a8-4f45-9b7e-1ae6c377d618",
          },
        }
      );

      if (smsResponse.status === 200) {
        console.log("SMS sent successfully!");
      } else {
        console.error("Failed to send SMS");
      }
      if (response.ok) {
        console.log("Email sent successfully!");
      } else {
        console.error("Failed to send email.");
      }
    } catch (error) {
      console.error("Error submitting appointment:", error.message);

      setMessages((prev) => [
        ...prev,
        {
          text: "Something went wrong while submitting your appointment. Please try again.",
          sender: "bot",
        },
      ]);
    }
  };

  const handleSend = async () => {
    if (!userInput.trim()) return;

    setMessages((prev) => [...prev, { text: userInput, sender: "user" }]);

    try {
      setIsBotTyping(true);

      const { responseText, parameters } = await queryDialogflow(userInput);

      let modifiedResponseText = responseText;

      if (parameters.date) {
        const formattedDate = parameters.date.split("T")[0];
        modifiedResponseText = modifiedResponseText.replace(
          "$date",
          formattedDate
        );
      }

      if (parameters.time) {
        const formattedTime = parameters.time.split("T")[1]?.split("+")[0];
        modifiedResponseText = modifiedResponseText.replace(
          "$time",
          formattedTime
        );
      }

      setMessages((prev) => [
        ...prev,
        {
          text: "",
          sender: "bot",
          isTyping: true,
        },
      ]);

      setTimeout(() => {
        setMessages((prev) => [
          ...prev.filter((msg) => !msg.isTyping),
          { text: modifiedResponseText, sender: "bot" },
        ]);
        setIsBotTyping(false);
      }, 2000);

      setCollectedData((prev) => ({
        ...prev,
        ...parameters,
      }));

      if (modifiedResponseText.toLowerCase().includes("please confirm")) {
        setShowConfirmation(true);
      }
    } catch (error) {
      console.error("Error communicating with Dialogflow: ", error);
    } finally {
      setUserInput("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSend();
    }
  };

  const handleYes = async () => {
    setShowConfirmation(false);
    await handleSubmit();
  };

  const handleNo = () => {
    setShowConfirmation(false);
    console.log("User chose no. Action cancelled.");
  };

  const renderMessage = (msg) => {
    let renderedText = msg.text;

    renderedText = renderedText.replace(
      /(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})\+(\d{2}:\d{2})/g,
      (match, date, time) => {
        return `${date} ${time}`;
      }
    );

    return (
      <p
        dangerouslySetInnerHTML={{
          __html: renderedText.replace(/\n/g, "<br />"),
        }}
      />
    );
  };

  return (
    <div className="chat-container">
      <div className="chatbot-container">
        <div
          className="chatbot-header"
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
          }}
        >
          {showAppointmentBotText ? <span>AppointmentBot - </span> : null}
          Iris
          <FaRobot style={{ marginLeft: "10px" }} />{" "}
        </div>
        <div className="chatbot-messages" ref={chatMessagesRef}>
          {messages.map((msg, index) => (
            <div
              key={index}
              className={`message ${
                msg.sender === "user" ? "user-message" : "bot-message"
              }`}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div style={{ marginRight: "4px", marginLeft: "4px" }}>
                {msg.sender === "bot" ? <FaRobot /> : <FaUser />}
              </div>
              <div>
                {" "}
                {msg.isTyping ? (
                  <div className="bot-typing">
                    <span className="dot"></span>
                    <span className="dot"></span>
                    <span className="dot"></span>
                  </div>
                ) : (
                  renderMessage(msg)
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="chatbot-input">
          {showConfirmation ? (
            <>
              <button className="button" onClick={handleYes}>
                Yes
              </button>
              <button className="button" onClick={handleNo}>
                No
              </button>
            </>
          ) : (
            <>
              <input
                className="text-input"
                type="text"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Type a message..."
              />
              <button className="send-button" onClick={handleSend}>
                <FaPaperPlane />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatComponent;
